const reviewsGrid = document.getElementById('reviews__grid');
const setReviewsGridHeight = (height) => {
    reviewsGrid.style.height = `${height}px`;
};

const adjustReviewsGridHeight = () => {
  const visibleItem = reviewsGrid.querySelector('.reviews__grid-item.is-visible');
  const itemHeight = visibleItem.clientHeight;
  setReviewsGridHeight(itemHeight);
}
adjustReviewsGridHeight();